import request, { METHODS } from '@/api'
import UrlConfig from '@/api/UrlConfigs'
import { get, isArray } from 'lodash-es'

/**
 * 评价配置列表
 */
export const evaluationConfigList = (pageId, pageSize, params) => {
  return request(`${UrlConfig.member.evaluationConfigList}?pageId=${pageId}&pageSize=${pageSize}`, {
    method: METHODS.POST,
    data: params,
  }).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
/**
 * 评价配置详情
 * @param options
 */
export const evaluationConf = id => {
  return request(`${UrlConfig.member.queryEvalutionConfigById}/${id}`, {
    method: METHODS.GET,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 评价指标列表
 */
export const evaluationIndexList = (pageId, pageSize, params) => {
  return request(`${UrlConfig.member.evaluationIndexList}?pageId=${pageId}&pageSize=${pageSize}`, {
    method: METHODS.POST,
    data: params,
  }).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
/**
 * 查询角色列表
 */
export const getRoleList = (params) => {
  return request(`${UrlConfig.Caas.GetRoleList}`, {
    method: METHODS.POST,
    data: params,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 查询评价标准模版数据
 */
export const evaluationMetricsTemplate = (params) => {
  return request(`${UrlConfig.member.evaluationMetricsTemplate}`, {
    method: METHODS.POST,
    data: params,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 通过条件查询评价指标分数标签列表
 */
export const evaluationMetricsConditionList = (params) => {
  return request(`${UrlConfig.member.evaluationMetricsConditionList}`, {
    method: METHODS.POST,
    data: params,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 分发记录列表
 */
export const evaluationRecordList = (pageId, pageSize, params) => {
  return request(`${UrlConfig.member.evaluationRecordList}?pageId=${pageId}&pageSize=${pageSize}`, {
    method: METHODS.POST,
    data: params,
  }).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
/**
 * 评价指标删除
 */
export const evaluationIndexDelete = id => {
  return request(`${UrlConfig.member.evaluationIndexDelete}/${id}`, {
    method: METHODS.DELETE,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 复制评价配置
 */
export const evalutionConfigCopy = id => {
  return request(`${UrlConfig.member.evalutionConfigCopy}/${id}`, {
    method: METHODS.GET,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 保存评价配置
 * @param options
 */
export const saveEvaluation = data => {
  return request(UrlConfig.member.saveEvaluation, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 保存评价配置
 * @param options
 */
export const evaluationDisable = (id, status) => {
  return request(`${UrlConfig.member.evaluationDisable}/${id}/${status}`, {
    method: METHODS.GET
  }).then((resp: any) => {
    return resp
  })
}

/**
 * 评价记录详情
 * @param options
 */
export const evaluationRecordDetail = id => {
  return request(`${UrlConfig.member.evaluationRecordDetail}/${id}`, {
    method: METHODS.GET,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 评价记录保存
 * @param options
 */
export const evaluationSave = data => {
  return request(UrlConfig.member.evaluationSave, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 评价指标保存
 * @param options
 */
export const evaluationIndexSave = data => {
  return request(UrlConfig.member.evaluationIndexSave, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 评价指标编辑
 * @param data
 */
export const evaluationIndexUpdateById = data => {
  return request(UrlConfig.member.evaluationIndexUpdateById, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 *  分发记录修改备注
 * @param options
 */
export const updateRemarkById = data => {
  return request(UrlConfig.member.updateRemarkById, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 *  分发记录修改赞点
 * @param data
 */
export const savePraise = data => {
  return request(UrlConfig.member.savePraise, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 *  分发记录导出
 * @param options
 */
export const downloadExcel = data => {
  return request(UrlConfig.Export.downloadExcel, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 *  问题分类-新增
 * @param data
 */
export const addEvaluationType = data => {
  return request(UrlConfig.member.addEvaluationType, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 *  问题分类-编辑
 * @param data
 */
export const updateEvaluationType = data => {
  return request(UrlConfig.member.updateEvaluationType, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 *  问题分类-改变状态
 * @param data
 */
export const updateStateEvaluationType = data => {
  return request(UrlConfig.member.updateStateEvaluationType, {
    method: METHODS.GET,
    params: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 *  问题分类-获取树形
 * @param data
 */
export const getTreeEvaluationType = data => {
  return request(UrlConfig.member.getTreeEvaluationType, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 删除问题分类
 */
export const delEvaluationType = id => {
  return request(`${UrlConfig.member.delEvaluationType}/${id}`, {
    method: METHODS.DELETE,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 满意度报表-城市维度
 */
export const companySatisfactionReport = (params) => {
  return request(`${UrlConfig.Report.CompanySatisfactionReport}`, {
    method: METHODS.POST,
    data: params,
  }).then((resp: any) => {
    const data = isArray(resp) ? resp : [];
    return{ records: data, total: 0 };
  })
}
/**
 * 满意度报表-员工维度
 */
export const staffSatisfactionReport = (params) => {
  return request(`${UrlConfig.Report.StaffSatisfactionReport}`, {
    method: METHODS.POST,
    data: params,
  }).then((resp: any) => {
    const data = isArray(resp) ? resp : [];
    return{ records: data, total: 0 };
  })
}
// 异步导出
export const asyncImportExportTaskDownloadExcel = data => {
  return request(UrlConfig.Export.ImportExportTaskDownloadExcel, {
    method: METHODS.POST,
    responseType: 'arraybuffer',
    raw: true,
    data,
  });
};